import { Tools } from "../classes/Tools";
import { Page } from "../classes/Page";
import { SearchService } from '../services/SearchService';

export class SearchPage {

  _searchPageWrapperEl;
  _searchInputEl;
  _currentSearch;
  _currentPage;
  _searchTermEl;
  _paginationInfoEl;
  _results = [];
  _resultsPerPage = 10;
  _totalResults;
  _searchPageWrapperContainerEl;
  _resultsListEl;
  _pageLang = Page.getLanguage();
  _paginationEl;
  _totalPages;
  _arrowsListenersInitialized = false;
  _searchService;

  constructor() {
    this._searchService = new SearchService();
  }

  init() {
    this._searchPageWrapperEl = document.querySelector('.search-page-wrapper');

    if (this._searchPageWrapperEl) {
      this.afterPageRender();

      window.addEventListener('popstate', () => {
        this.initParamsValues();
        this.initPagination();
        this.paginateResults();

        setTimeout(this.scrollPageTop.bind(this));
      });
    }
  }

  afterPageRender() {
    this._searchInputEl = this._searchPageWrapperEl.querySelector('input[type="search"]');
    this._searchPageWrapperContainerEl = this._searchPageWrapperEl.querySelector('.container');
    this._searchTermEl = this._searchPageWrapperEl.querySelector('.search-term span');
    this._paginationInfoEl = this._searchPageWrapperEl.querySelector('.pagination-info');
    this._resultsListEl = this._searchPageWrapperEl.querySelector('ul.results');
    this._paginationEl = this._searchPageWrapperEl.querySelector('.pagination');

    this.initParamsValues();
    this.apiCall();
  }

  initParamsValues() {
    this._currentSearch = Tools.getParam('s');
    this._currentPage = +Tools.getParam('page') || 1;
    this._searchInputEl.value = this._currentSearch;
    this._searchTermEl.textContent = this._currentSearch;
  }

  apiCall() {
    const loaderEl = document.createElement('div');
    loaderEl.classList.add('position-relative', 'loader-wrapper');
    loaderEl.innerHTML = `<div class="loader loader--md"></div>`;

    this._searchPageWrapperContainerEl.appendChild(loaderEl);
    this._results = [];

    this._searchService.search(Page.getLanguage(), this._currentSearch).then(res => {
      this._results = res.data;
      this._totalResults = this._results.length;
      this._totalPages = Math.ceil(this._totalResults / this._resultsPerPage);

    }).catch(() => {
    }).finally(() => {
      this.initPagination();
      this.paginateResults();
      loaderEl.remove();
    });

  }

  initPagination() {
    const [arrowLeft, arrowRight] = this._paginationEl.querySelectorAll('#arrow-left, #arrow-right');
    const pagesListEl = this._paginationEl.querySelector('ul.pages');

    pagesListEl.innerHTML = '';

    const setArrowsCls = () => {
      if (this._totalPages > 1) {
        if (this._currentPage === 1) {
          arrowLeft.classList.add('inactive');
          arrowRight.classList.remove('inactive');
        } else if (this._currentPage === this._totalPages) {
          arrowRight.classList.add('inactive');
          arrowLeft.classList.remove('inactive');
        } else {
          arrowLeft.classList.remove('inactive');
          arrowRight.classList.remove('inactive');
        }
      } else {
        arrowLeft.classList.add('inactive');
        arrowRight.classList.add('inactive');
      }
    };

    setArrowsCls();

    for (let page = 0; page < this._totalPages; page++) {
      const liEl = document.createElement('li');

      liEl.textContent = (page + 1).toString();

      if (page + 1 === this._currentPage) {
        liEl.classList.add('active');
      }

      liEl.addEventListener('click', () => {
        const newUrl = new URL(window.location.href);
        this._currentPage = page + 1;
        newUrl.searchParams.delete('page');
        newUrl.searchParams.append('page', this._currentPage);
        pagesListEl.querySelectorAll('li').forEach(x => x.classList.remove('active'));
        liEl.classList.add('active');
        history.pushState({}, null, newUrl.href);
        setArrowsCls();
        this.paginateResults();
        this.scrollPageTop();
      });

      pagesListEl.appendChild(liEl);
    }

    if (!this._arrowsListenersInitialized) {
      arrowLeft.addEventListener('click', () => pagesListEl.querySelectorAll('li')[this._currentPage - 2].click());
      arrowRight.addEventListener('click', () => pagesListEl.querySelectorAll('li')[this._currentPage].click());

      this._arrowsListenersInitialized = true;
    }
  }

  paginateResults() {
    const sliceResults = this._results.slice(
      (this._currentPage - 1) * this._resultsPerPage, this._currentPage * this._resultsPerPage
    );
    if (sliceResults.length > 0) {
      this._paginationEl.classList.remove('d-none');
      this._resultsListEl.innerHTML = sliceResults.map(x => {
        return `
            <li>
              <strong>${ x.title || '' }</strong>
              <p>${ x.highlights || '' }</p>
              <a href=${ x.url } target="_blank" class="primary md btn log-in-btn text-nowrap">
                ${ this._pageLang === 'de' ? 'Weiterlesen' : this._pageLang === 'pl' ? 'Czytaj więcej' : 'Read more' }
              </a>
            </li>
          `;
      }).join('');
      this._paginationInfoEl.querySelector('.total').textContent = this._totalResults.toString();
      this._paginationInfoEl.querySelector('.per-page').textContent = sliceResults.length;
      this._paginationInfoEl.classList.remove('d-none');
    } else {
      this._resultsListEl.innerHTML = '';
      const noResultsEl = document.createElement('div');

      noResultsEl.classList.add('no-results');
      noResultsEl.innerHTML = `
          <strong>${ this._pageLang === 'de' ? 'Keine Suchergebnisse' : this._pageLang === 'pl' ? 'Brak wyników wyszukiwania' : 'No search results' }</strong>
          <p>
            ${
        this._pageLang === 'de' ? 'Bitte suchen Sie nach einem anderen Begriff oder <a href="/de/contact/" target="_blank" class="primary text-color-brand">kontaktieren Sie uns</a>' :
          this._pageLang === 'pl' ? 'Proszę poszukać innego terminu lub <a href="/pl/contact/" target="_blank" class="primary text-color-brand">skontaktować się z nami</a>' :
            'Please search for another term or <a href="/en/contact/" target="_blank" class="primary text-color-brand">contact us</a>'
      }
          </p>
          <img src="/assets/img/illustrations/no-results.svg" alt="no results illustration">
        `;

      this._searchPageWrapperContainerEl.appendChild(noResultsEl);
    }
  }

  scrollPageTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
